import cn from 'classnames';
type Props = {
  type: 'vertical' | 'horizontal';
};
const CardLoading = ({ type }: Props) => {
  return (
    <>
      <div
        className={cn(
          'flex animate-pulse flex-col gap-4 rounded-[8px] border-[1px] border-solid border-[#E6E9EC] p-4',
          {
            'h-64 w-96': type === 'horizontal',
            'h-24 w-full': type === 'vertical',
          }
        )}
      >
        {type === 'vertical' ? (
          <>
            <div className="bg-neutral-15 h-4 w-1/2 animate-pulse rounded-[8px]"></div>
            <div className="bg-neutral-15 h-4 w-1/3 animate-pulse rounded-[8px]"></div>
          </>
        ) : (
          <>
            <div className="bg-neutral-15 h-4 w-1/3 animate-pulse rounded-[8px]"></div>
            <div className="bg-neutral-15 h-4 w-1/3 animate-pulse rounded-[8px]"></div>
            <div className="bg-neutral-15 h-4 w-1/3 animate-pulse rounded-[8px]"></div>
          </>
        )}
      </div>
    </>
  );
};
export default CardLoading;
